var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosHomePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H16C17.1046 0 18 0.89543 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0ZM9 4C9.55228 4 10 4.44772 10 5V8H13C13.5523 8 14 8.44772 14 9C14 9.55228 13.5523 10 13 10H10V13C10 13.5523 9.55228 14 9 14C8.44772 14 8 13.5523 8 13V10H5C4.44772 10 4 9.55228 4 9C4 8.44772 4.44772 8 5 8H8V5C8 4.44772 8.44772 4 9 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosHomePlus);
export default __webpack_public_path__ + "static/media/ios_home_plus.3f14830ebd0d935ac23566dec7c5292f.svg";
export { ForwardRef as ReactComponent };